import { useEffect, useState } from "react";
import { GetNewId } from "shared/utility/CommonUtility";
import {
  Validator,
  EmailRule,
  RequiredRule,
  StringLengthRule,
  PatternRule,
} from "devextreme-react/validator";
import TextBox, { ITextBoxOptions } from "devextreme-react/text-box";
import { dxTextBoxOptions } from "devextreme/ui/text_box";
import InputProps from "interfaces/InputProps";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import {
  getSizeSpecificClasses,
  getControlRadius,
} from "shared/utility/ControlUtility";
import "./styles/Controls.css";

export interface InputFeildProps
  extends dxTextBoxOptions,
    ITextBoxOptions,
    InputProps {}

export default function InputField(
  props: InputFeildProps
) {
  const { className: propClassName, controlRef, onValidated, ...rest } = props;
  const { id, label, required, maxLength, mode, size, radiusSize } = props;
  const [validatorRules, setValidatorRules] = useState<any>([]);

  useEffect(() => {
    const phonePattern = /^\+\s*1\s*\(\s*[02-9]\d{2}\)\s*\d{3}\s*-\s*\d{4}$/;

    const setValidationRules = () => {
      const rules = [];
      if (required) {
        const rule = (
          <RequiredRule
            key={`${GetNewId()}-${id}`}
            message={`${label} is required.`}
          />
        );
        rules.push(rule);
      }

      if (maxLength) {
        const rule = (
          <StringLengthRule
            key={`${GetNewId()}-${id}`}
            max={maxLength}
            message={`Max length is ${maxLength}`}
          />
        );
        rules.push(rule);
      }

      if (mode === "email") {
        const rule = (
          <EmailRule
            key={`${GetNewId()}-${id}`}
            message="Please use a valid email address."
          />
        );
        rules.push(rule);
      }

      if (mode === "tel") {
        const rule = (
          <PatternRule
            message="Please use a valid phone number."
            pattern={phonePattern}
          />
        );
        rules.push(rule);
      }

      setValidatorRules(rules);
    };

    setValidationRules();
  }, [id, label, maxLength, mode, required]);

  const getClassNames = () => {
    const classNames = `${getSizeSpecificClasses(
      size
    )} prom-control border-1.5 border-silver outline-none ${getControlRadius(
      radiusSize
    )}`;
    return propClassName ? `${classNames} ${propClassName}` : classNames;
  };

  return (
    <TextBox {...rest} className={getClassNames()} ref={controlRef}>
      <Validator onValidated={onValidated}>{validatorRules}</Validator>
    </TextBox>
  );
}

InputField.defaultProps = {
  size: ControlSize.Midium,
  radiusSize: ControlSize.Large,
};
